import React, { Component } from 'react'
import { Helmet } from 'react-helmet'
import LazyLoad from 'react-lazy-load';
import NewsletterForm from '../../components/newletter-form'
// import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro' 

class PhysicalStorePage extends Component {

	constructor() {
		super()
		this.state = { showMoreProducts: false }
	}

	render() {
		// const rowCountProducts = Math.ceil((this.props.storecontent.products.length) / 4.0)
		const storeColSize = "column-21 w-col w-col-" + (Math.ceil(12.0 / this.props.storecontent.stores.length).toString());
		const storePreviews = this.props.storecontent.stores.map(
			(s, k) =>
				<div key={s.uid} id={s.slug} className={storeColSize}>
					<a href={'/stores/' + s.slug + '#start'} className="store-link-block w-inline-block">
						<img src={s.preview.cover} sizes="(max-width: 479px) 100vw, (max-width: 767px) 92vw, 30vw" alt="" className="image-13" />
						<h3 className="font-headline primary">{s.preview.title}</h3>
						<p className="address">
							{s.preview.address}
						</p>
					</a>
				</div>
		);
		const storeLinks = this.props.storecontent.stores.map(
			(s, k) =>
				<a key={k} href={"/stores/" + s.slug + "#products"} className="button small secondary margin-right-16px w-inline-block w-clearfix">
					<div className="text-block-3">See all products in {s.name}</div><img src="images/ARROW-F.svg" height="16" width="16" alt="" className="icon _16px black" />
				</a>
		);
		const main = this.props.storecontent.maincontent;
		const partner = this.props.storecontent.partnercontent;
		// console.log("PARTNER",partner);
		// const contactevent = this.props.storecontent.contactevent;
		const contactproduct = this.props.storecontent.contactproduct;
		const seo = this.props.storecontent.seo, generic = this.props.storecontent.social.generic[0], twitter = this.props.storecontent.social.twitter[0];
		var blockLazy = (/blocklazy/gi).test(window.location.href);

		let allProducts = {}
		for (let i in this.props.storecontent.products) {
			if (this.props.storecontent.products[i].type) {
				if (!allProducts[this.props.storecontent.products[i].type]) {
					allProducts[this.props.storecontent.products[i].type] = []
				}
				allProducts[this.props.storecontent.products[i].type].push(this.props.storecontent.products[i])
			}
		}
		console.log(allProducts)

		console.log()
		var sc = document.createElement("script");
		sc.setAttribute("type", "application/ld+json");
		sc.text = `
				{
			      "@context":"https://schema.org",
			      "@type":"ItemList",
			      "itemListElement": [
			      	{
			      		"@type": "ListItem",
      					"position": 1,
			            "item": {
			                  "@type": "BookStore",
			                  "parentOrganization": {
			                        "name" : "Startup Guide"
			                  },
			                  "name": "Startup Guide Store Berlin",
			                  "image": "https://prismic-io.s3.amazonaws.com/startupguide%2Fbc801a2a-e533-4097-b510-a5cf9b7961fd_header_2.jpg",
			                  "@id": "https://startupguide.com/stores#berlin",
			                  "url": "https://startupguide.com/stores#berlin",
			                  "telephone": "+49 30 21600662",
			                  "priceRange": "Starting at 20€",
			                  "address": {
			                        "@type": "PostalAddress",
			                        "streetAddress": "Maybachufer 6",
			                        "addressLocality": "Berlin",
			                        "postalCode": "12047",
			                        "addressCountry": "DE"
			                  },
			                  "geo": {
			                        "@type": "GeoCoordinates",
			                        "latitude": 52.49509,
			                        "longitude": 13.422460000000001
			                  },
			                  "openingHoursSpecification": {
			                        "@type": "OpeningHoursSpecification",
			                        "dayOfWeek": [
			                        "Monday",
			                        "Tuesday",
			                        "Wednesday",
			                        "Thursday",
			                        "Friday"
			                        ],
			                        "opens": "10:00",
			                        "closes": "18:00"
			                  },
			                  "sameAs": "https://www.facebook.com/Startup-Guide-1300574450082230/"
			            }
			        },
			        {
			      		"@type": "ListItem",
      					"position": 2,
			            "item": {	
			                  "@type": "BookStore",
			                  "parentOrganization": {
			                        "name" : "Startup Guide"
			                  },
			                  "name": "Startup Guide Store Copenhagen",
			                  "image": "https://prismic-io.s3.amazonaws.com/startupguide%2F5aef7aa6-d94d-45fa-b85f-b8906188e301_copenhagen_store.jpg",
			                  "@id": "https://startupguide.com/stores#copenhagen",
			                  "url": "https://startupguide.com/stores#copenhagen",
			                  "telephone": "+45 51791958",
			                  "priceRange": "Starting at 20€",
			                  "address": {
			                        "@type": "PostalAddress",
			                        "streetAddress": "Borgbjergsvej 1",
			                        "addressLocality": "Copenhagen",
			                        "postalCode": "2450",
			                        "addressCountry": "DK"
			                  },
			                  "geo": {
			                        "@type": "GeoCoordinates",
			                        "latitude": 55.6523462,
			                        "longitude": 12.538717
			                  },
			                  "openingHoursSpecification": [{
			                        "@type": "OpeningHoursSpecification",
			                        "dayOfWeek": ["Monday", "Wednesday"],
			                        "opens": "9:00",
			                        "closes": "17:30"
			                  },
			                  {
			                        "@type": "OpeningHoursSpecification",
			                        "dayOfWeek": ["Tuesday", "Thursday", "Friday"],
			                        "opens": "9:00",
			                        "closes": "16:00"
			                  }],
			                  "sameAs": "https://www.facebook.com/Startup-Guide-621239024981086/"
			            }
			        },
			        {
			      		"@type": "ListItem",
			      		"position": 3,
			            "item": {
			                  "@type": "BookStore",
			                  "parentOrganization": {
			                        "name" : "Startup Guide"
			                  },
			                  "name": "Startup Guide Store Lisbon",
			                  "image": "https://prismic-io.s3.amazonaws.com/startupguide%2F64e09dc2-a17e-4163-8e57-10d525b4628f_store_header.jpg",
			                  "@id": "https://startupguide.com/stores#lisbon",
			                  "url": "https://startupguide.com/stores#lisbon",
			                  "telephone": "+351 211 398 791",
			                  "priceRange": "Starting at 20€",
			                  "address": {
			                        "@type": "PostalAddress",
			                        "streetAddress": "Rua do Grilo 135",
			                        "addressLocality": "Lisbon",
			                        "postalCode": "1950-144",
			                        "addressCountry": "PT"
			                  },
			                  "geo": {
			                        "@type": "GeoCoordinates",
			                        "latitude": 38.729884,
			                        "longitude": -9.108052
			                  },
			                  "openingHoursSpecification": {
			                        "@type": "OpeningHoursSpecification",
			                        "dayOfWeek": [
			                        "Monday",
			                        "Tuesday",
			                        "Wednesday",
			                        "Thursday",
			                        "Friday"
			                        ],
			                        "opens": "10:00",
			                        "closes": "19:00"
			                  },
			                  "sameAs": "https://www.facebook.com/Startup-Guide-423528815083590/"
			            }
			        }
			      ]
			}
            `
		document.head.appendChild(sc);

		return (
			<div>
				<Helmet>
					<title>Startup Guide - {seo.title ? seo.title : "Stores"}</title>
					<meta content={seo.description ? seo.description : main.maindescription} name="description" />

					<meta content="website" property="og:type" />
					<meta content={generic && generic.title ? generic.title : 'Stores'} property="og:title" />
					<meta content={generic && generic.description ? generic.description : main.maindescription} property="og:description" />
					<meta content={generic && generic.image ? generic.image : this.props.stores[0].preview.cover} property="og:image" />
					<meta property="og:url" content="https://startupguide.com/stores"></meta>
					<meta property="og:site_name" content="StartupGuide"></meta>

					<meta name="twitter:card" content={twitter && twitter.type.includes('Standard') ? 'summary' : 'summary_large_image'}></meta>
					<meta name="twitter:site" content="@StartupGuideHQ"></meta>
					<meta name="twitter:creator" content={twitter && twitter.handle ? twitter.handle : '@StartupGuideHQ'}></meta>
					<meta name="twitter:title" content={twitter && twitter.title ? twitter.title : "Categorias"}></meta>
					<meta name="twitter:description" content={twitter && twitter.description ? twitter.description : "Categorias"}></meta>
					<meta name="twitter:image" content={twitter && twitter.image ? twitter.image : this.props.stores[0].preview.cover}></meta>
				</Helmet>

				<div className="page-title-stores" style={{ height: 'fit-content' }}>
					<img id="start" src={this.props.storecontent.banner} style={{ opacity: '0', width: '100%' }} alt="" />
					<div style={{
						width: '100%',
						display: 'block',
						height: '100%',
						backgroundImage: 'url(\'' + this.props.storecontent.banner + '\'',
						position: 'absolute',
						top: 0,
						backgroundSize: 'cover',
						backgroundPosition: 'center'
					}}
					/>
					<div className="description">
						<div className="text-block-65">Stores</div>
						<p className="paragraph smal">{main.intro}</p>
					</div>
				</div>
				{!blockLazy &&
					<LazyLoad offset={100} debounce={false}>
						<div className="stores-location-container">
							<div className="stores-berlin-lisbon">
								<div className="columns-4 w-row">
									{storePreviews}
								</div>
							</div>
						</div>
					</LazyLoad>
				}
				{blockLazy &&
					<div className="stores-location-container">
						<div className="stores-berlin-lisbon">
							<div className="columns-4 w-row">
								{storePreviews}
							</div>
						</div>
					</div>
				}
				<div className="stores-description grid-store-description">
					<div className="description-stores" style={{ borderTop: '0px' }}>
						<div className="stores-description-row w-row productTableColumns" style={{ marginTop: '0px' }}>
							<div className="stores-description-column-left w-col w-col-12">
								<div>
									<blockquote className="p-blockquote-copy" style={{ maxWidth: "570px" }}>We're stockists for global magazines and books Find your favorites paper products in our stores.</blockquote>
									<div className="row-grid-product" style={{
										maxHeight: !this.state.showMoreProducts ? '280px' : 'unset',
									}}>
										<span><strong>Indie Magazines</strong></span>
										{allProducts['Indie Magazines'] && allProducts['Indie Magazines'].map((p, k) =>
											<span><a className="link-18" href={p.link} target="_blank">{p.name}</a></span>
										)}
									</div>
								</div>
							</div>
						</div>
						<div key="showmore" className="button-show-more-products">
							<a
								data-w-id="72028f29-0ac2-fd2f-c466-6ae180529edb"
								className="discover-more-category busines w-button"
								style={{
									background: '#e1e1e1',
									color: '#7E7E7E',
									border: 0,
									display: !this.state.showMoreProducts ? 'block' : 'none',
								}}
								onClick={() => this.setState({ showMoreProducts: true })}
							>
								SHOW&nbsp;MORE
							</a>
						</div>
						<div className="stores-description-row w-row productTableColumns" style={{ marginTop: '0px', alignItems: 'flex-start' }}>
							<div className="stores-description-column-left w-col w-col-4" style={{ paddingTop: '50px', marginRight: '10px' }}>
								<div className="row-grid-product" style={{ maxHeight: 'none' }}>
									<span><strong>Books</strong></span>
									{allProducts['Books, Notebooks and Agendas'] && allProducts['Books, Notebooks and Agendas'].map((p, k) =>
										<span><a className="link-18" href={p.link} target="_blank">{p.name}</a></span>
									)}
								</div>
							</div>
							<div className="stores-description-column-left w-col w-col-3" style={{ paddingTop: '50px', marginRight: '10px' }}>
								<div className="row-grid-product" style={{ maxHeight: 'none' }}>
									<span><strong>Games</strong></span>
									{allProducts['Cards & Games'] && allProducts['Cards & Games'].map((p, k) =>
										<span><a className="link-18" href={p.link} target="_blank">{p.name}</a></span>
									)}
								</div>
							</div>
							<div className="stores-description-column-left w-col w-col-4">
							</div>
							<div className="stores-description-column-left w-col w-col-4">
								<img src={main.footer_product_image} width="437" sizes="(max-width: 479px) 216.9375px, (max-width: 991px) 46vw, 437px" alt="" className="image-108" />
							</div>
						</div>
						<div className="buttons-container-stores w-clearfix" style={{ paddingTop: '60px', marginBottom: '30px' }}>
							{storeLinks}
						</div>
					</div>
				</div>
				{!blockLazy &&
					<LazyLoad offset={100} debounce={false}>
						<div className="stores-description">
							<div className="description-stores" style={{ borderTop: '0px' }}>
								<div className="stores-description-row w-row productTableColumns">
									<div className="stores-description-column-left w-col w-col-6">
										<div className="div-block-167">
											<blockquote className="p-blockquote-copy">{main.mainhighlight}</blockquote>
											<p className="paragraph left-aligned _600">{main.maindescription}</p>
										</div>
									</div>
									<div className="stores-description-column-right w-col w-col-6 w-hidden-small w-hidden-tiny"><img src={main.mainpicture} style={{ maxHeight: '380px' }} width="437" sizes="(max-width: 479px) 216.9375px, (max-width: 991px) 46vw, 437px" alt="" className="image-108" /></div>
								</div>
								<div className="stores-description-row w-row productTableColumns">
									<div className="stores-description-column-left illustration w-col w-col-7">
										<img src={partner[0].partnerpicture} width="325" sizes="(max-width: 767px) 100vw, 325px" alt="" />
									</div>
									<div className="stores-description-column-right w-col w-col-5">
										<div style={{ "width": "100%", "marginBottom": "-10px", marginTop: '20px' }}><h6 className="heading-25">Official partners:</h6></div>
										{partner.map((p, k) =>
											<div key={k} className="official-partner" style={{ marginBottom: '50px' }}>
												<img src={p.partnertitle} width="344" alt="" className="image-107" style={{ marginBottom: '30px' }} />
												<p className="paragraph left-aligned">{p.partnerdescription}</p>
											</div>
										)}
									</div>
								</div>
							</div>
						</div>
					</LazyLoad>
				}
				{blockLazy &&
					<div className="stores-description">
						<div className="description-stores" style={{ borderTop: '0px' }}>
							<div className="stores-description-row w-row">
								<div className="stores-description-column-left w-col w-col-6">
									<div className="div-block-167">
										<blockquote style={{ fontSize: "23px" }} className="p-blockquote-copy">{main.mainhighlight}</blockquote>
										<p className="paragraph left-aligned _600">{main.maindescription}</p>
									</div>
								</div>
								<div className="stores-description-column-right w-col w-col-6"><img src={main.mainpicture} width="437" sizes="(max-width: 479px) 216.9375px, (max-width: 991px) 46vw, 437px" alt="" className="image-108" /></div>
							</div>
							<div className="stores-description-row w-row">
								<div className="stores-description-column-left illustration w-col w-col-7 w-hidden-small w-hidden-tiny">
									<img src={partner[0].partnerpicture} width="325" sizes="(max-width: 767px) 100vw, 325px" alt="" />
								</div>
								<div className="stores-description-column-right w-col w-col-5">
									<div style={{ "width": "100%", "marginBottom": "-10px" }}><h6 className="heading-25">Official partners:</h6></div>
									{partner.map((p, k) =>
										<div key={k} className="official-partner">
											<img src={p.partnertitle} width="344" alt="" className="image-107" style={{ marginTop: '50px', marginBottom: '30px' }} />
											<p className="paragraph left-aligned">{p.partnerdescription}</p>
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				}

				{!blockLazy &&
					<LazyLoad offset={100} debounce={false}>
						<div className="stores-page-footer" style={{ padding: "0px 0px 90px 0px" }}>
							<div className="store-info">
								<div className="page-footer-row w-row">
									<div className="page-footer-column-left w-col w-col-7">
										<h3 className="margin-bottom-16px">{contactproduct.title}</h3>
										<p className="paragraph left-aligned margin-bottom-0px">{contactproduct.description}<br />‍<br />Contact: <a href={"mailto:" + contactproduct.contact + "?subject=We%20want%20our%20product%20on%20Startup%20Guide%20Store!"} className="link-18">{contactproduct.contact}</a></p>
									</div>
								</div>
							</div>
						</div>
					</LazyLoad>
				}
				{blockLazy &&
					<div className="stores-page-footer" style={{ padding: "0px 0px 90px 0px" }}>
						<div className="store-info">
							<div className="page-footer-row w-row">
								<div className="page-footer-column-left w-col w-col-7">
									<h3 className="margin-bottom-16px">{contactproduct.title}</h3>
									<p className="paragraph left-aligned margin-bottom-0px">{contactproduct.description}<br />‍<br />Contact: <a href={"mailto:" + contactproduct.contact + "?subject=We%20want%20our%20product%20on%20Startup%20Guide%20Store!"} className="link-18">{contactproduct.contact}</a></p>
								</div>
							</div>
						</div>
					</div>
				}
				<NewsletterForm />
			</div>
		);
	}
}

export default PhysicalStorePage;